import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
import { Mining } from "@assets/js/Mining.js";
export default {
  name: "lucky",
  computed: {
    ...userVuex.mapState(["isLogin", "userInfo"]),
    ...taskVuex.mapState(["taskInfo", "timerObjs"])
  },
  data() {
    return {
      mintBotPercent: 0,
      miningObj: null,
      mintBotSimpleCount: 0,
      storageInfo: {
        capacity: 0,
        stock: {
          coins: 0,
          percent: 0
        }
      },
      hasActive: null
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {
          // this.setWowAnim();
          this.calcMintBot();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    onSkip(path) {
      this.hapticFeedback();
      this.$router.push(path);
    },
    async calcMintBot() {
      const res = await this.$http.post("/mining/info", {
        simple: 0
      });
      if (!res) {
        return;
      }
      if (res.code > 0) {
        return;
      }
      this.hasActive = res?.data?.miner?.list?.some(item => item.active === true);
      console.log("hasActive", this.hasActive);
      if (!this.hasActive) return;
      this.miningObj = new Mining(res.data);
      this.calcMining(null, false);
      this.poolMinning();
    },
    calcMining(res) {
      const calcRes = this.miningObj.reset(res);
      console.log("calcRescalcRes", calcRes);
      const stock = calcRes.stock;
      this.storageInfo.stock = stock;
    },
    poolMinning() {
      clearTimeout(this.timerObjs.botPage.miningTimer);
      this.timerObjs.botPage.miningTimer = setTimeout(async () => {
        this.mintBotSimpleCount++;
        const mintBotSimpleMax = 20;
        if (this.mintBotSimpleCount >= mintBotSimpleMax) {
          const res = await this.$http.post("/mining/info", {
            simple: 0
          });
          if (res.code > 0) {
            return;
          }
          if (res) {
            this.calcMining(res, false);
          }
          this.mintBotSimpleCount = 0;
        } else {
          this.calcMining(null, false);
        }
        this.poolMinning();
      }, 1000);
    }
  },
  beforeDestroy() {
    console.log(888888888);
    clearTimeout(this.timerObjs.botPage.miningTimer);
  },
  mounted() {
    this.setWowAnim();
  }
};